import '../scss/main.scss';

// Bootstrap components – imported for side-effects (auto-init via data attributes)
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/tooltip';
import { Slider } from './Slider';
import { JumpNavigation } from './JumpNavigation';
import { BurgerMenu } from './BurgerMenu';
import { ScrollAnimations } from './ScrollAnimations';
import { CookieConsent } from './CookieConsent';
import { Accordion } from './Accordion';

document.addEventListener('DOMContentLoaded', () => {
  // Cookie Consent
  new CookieConsent();

  // Mobile burger menu toggle
  new BurgerMenu();

  // Scroll-Animationen
  new ScrollAnimations();

  // Animation-Toggle-Button
  const animToggle = document.getElementById('animation-toggle') as HTMLButtonElement | null;
  if (animToggle) {
    const syncToggle = (): void => {
      const disabled = ScrollAnimations.isDisabled();
      animToggle.setAttribute('aria-pressed', String(disabled));
      animToggle.textContent = disabled ? 'Animationen (aus)' : 'Animationen (an)';
    };
    syncToggle();
    animToggle.addEventListener('click', () => {
      ScrollAnimations.toggle();
      syncToggle();
    });
  }

  // Jump navigation – auto-generated from section[data-nav-label]
  new JumpNavigation();

  // Accordion
  Accordion.initAll();

  // Teaser-with-image grids → mobile slider
  Slider.initAll('.teaser-with-image__grid', {
    slideSelector: '.teaser-with-image__card',
  });

  // Scroll-Progress: width + aria-valuenow synchron halten
  const progressBar = document.getElementById('scroll-progress');
  if (progressBar) {
    const updateProgress = (): void => {
      const scrolled = window.scrollY;
      const total = document.documentElement.scrollHeight - window.innerHeight;
      const pct = total > 0 ? Math.round((scrolled / total) * 100) : 0;
      progressBar.style.width = `${pct}%`;
      progressBar.setAttribute('aria-valuenow', String(pct));
    };
    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }
});
